import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import {useAuth} from '../../../hook' ;
import './TopMenu.scss';
import { ExpandMore } from '@mui/icons-material';
import { getInitialLetter } from '../../../utils/getInitialLetter';
import { Link } from 'react-router-dom';

export function TopMenu() {
    //Obteniendo datos del usuario en Hook useAuth
    const {logout, auth} = useAuth();
    const {me} = auth;

    const renderName = () =>{
        if(me?.first_name){
            return me.first_name
        }else{
            return me.username
        }
    }

    //Agregado para dropdown menu
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const handleSelect = (value) => {
      console.log('Seleccionado:', value);
      handleClose();
    };

  return (
    <>
    <div className='top_menu'>
    <div className='row-sb middle'>
            <div className='logo_menu'></div>
            
            <div className='data_menu'>                    
                    <button onClick={handleClick}>                      
                       <span className='letter'>
                         {getInitialLetter(me?.first_name)}                         
                       </span>
                       <ExpandMore />                     
                    </button>
                    
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >                        
                        <MenuItem>
                            <Link onClick={()=> handleClose()}to='/admin/settings'>Configuración</Link>
                        </MenuItem>
                        <MenuItem onClick={logout}>Cerrar sesión</MenuItem>
                    </Menu>


            </div>
        </div>   
     </div>
    </>
    
        
  
  )
}
